/* LONDA: a height/weight estimate against the published size chart. No automatic image generation. */
(() => {
  'use strict';
  const key = 'londa-size-advisor-v1';
  const format = range => range ? (range.min === range.max ? String(range.min) : range.min + '–' + range.max) : '—';
  const displaySize = size => String(size||'').normalize('NFKC').replace(/\s*[・･]\s*(?:即日発送|通常発送)\s*$/,'').trim();
  const isOneSize = size => /^(?:FREE(?:SIZE)?|ONESIZE|OS|OSFA|F|フリー(?:サイズ)?|ワンサイズ)$/i.test(displaySize(size).replace(/[\s_-]/g,''));

  class LondaSizeAdvisor extends HTMLElement {
    connectedCallback() {
      if (this.ready) {this.bindProductEvents();this.bindProfileEvents();return;}
      if (!this.chart || !this.labels) return;
      this.ready = true;
      const root = this.attachShadow({mode:'open'}), L = this.labels;
      root.innerHTML = `<style>
        :host{display:block;margin-top:24px;color:#232c37;font:14px/1.65 Arial,'Hiragino Sans',Meiryo,sans-serif;letter-spacing:0}
        *{box-sizing:border-box}[hidden]{display:none!important}
        section{padding:20px;border:1px solid #dce5eb;border-radius:8px;background:#fff}
        header{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:8px}
        h3{margin:0;font-family:inherit;font-size:18px;line-height:1.5;font-weight:600}
        p{margin:5px 0 13px;font-size:13px;color:#59626c}
        button,input{font:inherit}button{cursor:pointer;min-height:44px;border:1px solid #b7bbb7;border-radius:3px;background:white;color:#232c37;padding:8px 12px}
        header button{padding:7px 9px;font-size:12px;white-space:nowrap}
        label{display:flex;flex-direction:column;gap:5px;font-size:13px}
        input{width:100%;min-width:0;min-height:44px;border:1px solid #b7bbb7;border-radius:3px;padding:8px 10px;background:#fff;color:#232c37;font-size:16px}
        .fields{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px}
        .submit{width:100%;margin-top:14px;background:#171b1c;color:white;border-color:#171b1c;font-weight:600}
        button:focus-visible,input:focus-visible,summary:focus-visible,a:focus-visible,.table-scroll:focus-visible{outline:2px solid #375775;outline-offset:3px}
        .status{font-size:12px;color:#59626c;margin:8px 0}
        .result{margin-top:20px;padding-top:18px;border-top:1px solid #dedfdc}
        .recommend{padding:13px 15px;background:#edf5fa;border:1px solid #dae7ef;border-radius:5px;font-size:18px;font-weight:600;line-height:1.5}
        .recommend.unmatched{font-size:15px;background:#f0f1ef;color:#48534c}
        [data-detail]{margin:9px 2px 4px;line-height:1.7}
        [data-estimate-caution]{margin:3px 2px 12px;line-height:1.7}
        .model-reference{font-size:12px;padding:10px 12px;margin:12px 0;background:white;border:1px solid #e2e3df;border-radius:3px}
        .model-reference strong{display:block;font-weight:600}
        .model-reference span{display:block;color:#59626c;margin-top:3px}
        .size-details{margin-top:15px;border-top:1px solid #e0e2de}
        summary{min-height:44px;display:flex;align-items:center;justify-content:space-between;gap:12px;list-style:none;cursor:pointer;padding:12px 0;font-size:13px;color:#48534c}
        summary::-webkit-details-marker{display:none}summary:after{content:'＋';font-size:18px;font-weight:400}.size-details[open]>summary:after{content:'−'}
        .table-scroll{overflow-x:auto;margin:0 0 10px;max-width:100%}
        table{border-collapse:collapse;width:100%;background:white;font-size:12px;text-align:center}
        caption{text-align:left;padding:0 0 7px;color:#59626c;font-size:12px}
        th,td{padding:9px 10px;border:1px solid #e2e3df;white-space:nowrap}
        thead th{font-weight:400;background:#f5f5f3}tbody th{font-weight:600}
        tr[data-recommended]{background:#edf1ed}tr[data-recommended] th{box-shadow:inset 3px 0 #576b5f}
        .size-marker{display:block;font-size:10px;font-weight:400;color:#48534c}
        .help{margin:14px 0 6px;color:#59626c;font-size:13px}
        .footnote{font-size:12px;margin-bottom:0}
        @media(max-width:600px){section{padding:15px}h3{font-size:17px}.fields{gap:10px}header{gap:6px}header button{font-size:11px;padding:7px}.recommend{font-size:17px}.result{margin-top:17px;padding-top:16px}th,td{padding:8px}}
        @media(max-width:360px){section{padding-inline:8px}h3{font-size:14px;white-space:nowrap}header{gap:6px}header button{padding-inline:6px}}
      </style>
      <section><header><h3 data-text="title"></h3><button type="button" data-reset data-text="reset"></button></header><p data-text="intro"></p>
        <form novalidate>
          <div class="fields">
            <label><span data-text="height"></span><input name="height" type="number" inputmode="decimal" min="130" max="220" step="0.1" placeholder="163" required></label>
            <label><span data-text="weight"></span><input name="weight" type="number" inputmode="decimal" min="30" max="200" step="0.1" placeholder="55" required></label>
          </div>
          <button class="submit" type="submit" data-text="check"></button><p class="status" role="status" aria-live="polite" data-status hidden></p>
        </form>
        <div class="result" hidden>
          <div class="recommend" role="status" aria-live="polite" data-recommend></div><p data-detail></p>
          <div data-preview-mount></div>
          <p class="footnote" data-estimate-caution hidden data-text="result_caution"></p>
          <details class="size-details"><summary data-text="comparison_title"></summary>
            <div class="model-reference" hidden><strong data-model></strong></div>
            <div data-comparison></div>
            <p class="footnote" data-range-note hidden data-text="range_note"></p><p class="footnote" data-text="caution"></p>
            <p class="footnote" data-model-note hidden data-text="model_unknown_weight"></p>
          </details>
        </div>
        <p class="help" data-size-guidance data-text="line_help"></p><p class="footnote" data-text="privacy"></p>
      </section>`;
      root.querySelectorAll('[data-text]').forEach(e => e.textContent = L[e.dataset.text] || '');
      this.form = root.querySelector('form');this.result = root.querySelector('.result');this.status = root.querySelector('[data-status]');
      this.bindProductEvents();
      if ((this.fitPreviewCache || this.fitGenerationUrl) && customElements.get('londa-fit-preview')) {
        const preview = document.createElement('londa-fit-preview');
        Object.assign(preview,{productId:this.productId,productHandle:this.productHandle,productTitle:this.productTitle,cacheUrl:this.fitPreviewCache,lang:this.previewLanguage,generationUrl:this.fitGenerationUrl});
        root.querySelector('[data-preview-mount]').append(preview);
      }
      this.form.addEventListener('submit', e => {e.preventDefault();e.stopPropagation();this.calculate();});
      this.form.addEventListener('focusin', () => root.querySelector('londa-fit-preview')?.prepare());
      this.form.addEventListener('input', () => {this.profileReady=false;this.advice=null;this.result.hidden=true;this.status.hidden=true;root.querySelector('londa-fit-preview')?.clear();root.querySelector('londa-clothing-preview')?.remove();});
      root.querySelector('[data-reset]').addEventListener('click', () => {
        this.clearProfile();
        this.form.elements.height.focus();
      });
      this.bindProfileEvents();
      this.restoreProfile();
    }
    clearProfile() {
      this.form.reset();this.profileReady=false;this.advice=null;
      this.shadowRoot.querySelector('londa-fit-preview')?.clear();
      this.shadowRoot.querySelector('londa-clothing-preview')?.remove();
      this.result.hidden=true;this.status.hidden=true;
      try {localStorage.removeItem(key);} catch { /* Storage is optional. */ }
    }
    restoreProfile() {
      try {
        const saved=JSON.parse(localStorage.getItem(key)||'null');
        if(saved?.remember===true&&saved.height!==undefined&&saved.weight!==undefined){
          for(const name of ['height','weight'])if(saved[name]!==undefined)this.form.elements[name].value=saved[name];
          if(this.form.checkValidity()){this.calculate({persist:false,automatic:true});return;}
        }
      } catch { /* Input remains usable without storage. */ }
      this.clearProfile();
    }
    bindProfileEvents() {
      if(this.profileEventsBound)return;
      this.onProfileStorage=event=>{if(event.key===key||event.key===null)this.restoreProfile();};
      window.addEventListener('storage',this.onProfileStorage);this.profileEventsBound=true;
    }
    bindProductEvents() {
      const pdp=this.productHost?.closest('[data-londa-pdp]');
      if(pdp===this.productPdp){return;}
      this.productPdp?.removeEventListener('londa:variant-change',this.onVariantChange);
      this.productPdp?.removeEventListener('londa:product-facts',this.onVariantChange);
      this.productPdp=pdp;
      this.onVariantChange=()=>{
        if(this.result)this.result.hidden=true;
        if(this.status)this.status.hidden=true;
        this.shadowRoot?.querySelector('londa-fit-preview')?.clear();
        this.shadowRoot?.querySelector('londa-clothing-preview')?.remove();
        if(this.profileReady)this.calculate({persist:false,automatic:true});
        else {this.advice=null;}
      };
      this.productPdp?.addEventListener('londa:variant-change',this.onVariantChange);
      this.productPdp?.addEventListener('londa:product-facts',this.onVariantChange);
      
    }
    disconnectedCallback() {
      this.productPdp?.removeEventListener('londa:variant-change',this.onVariantChange);
      this.productPdp?.removeEventListener('londa:product-facts',this.onVariantChange);
      this.productPdp=null;
      if(this.profileEventsBound)window.removeEventListener('storage',this.onProfileStorage);
      this.profileEventsBound=false;
    }
    calculate({persist=true,automatic=false}={}) {
      const F=this.form.elements,L=this.labels,root=this.shadowRoot;
      if(!this.form.checkValidity()){
        if(!automatic){this.form.reportValidity();this.status.textContent=L.invalid;this.status.hidden=false;}
        return;
      }
      const pdp=this.productHost?.closest('[data-londa-pdp]');
      let variants=[],tags=[];
      try {variants=JSON.parse(this.productHost?.querySelector('[data-londa-fit-variants]')?.textContent||'[]');}catch {}
      try {tags=JSON.parse(this.productHost?.dataset.productTags||'[]');}catch {}
      const currentVariantId=pdp?.dataset.variantId||pdp?.querySelector('[data-lpd-id]')?.value||new URL(location.href).searchParams.get('variant');
      const advice=LondaFitCatalog.recommendForProduct({
        chart:this.chart,title:this.productTitle,productHandle:this.productHandle,tags,variants,currentVariantId,
        height:Number(F.height.value),weight:Number(F.weight.value),modelText:pdp?.dataset.londaModelInfo||''
      });
      const best=advice.status==='recommended'?advice.best:null,reference=advice.reference;
      this.body=advice.body;this.advice=advice;
      const messages={
        no_stock:[L.no_stock,L.no_stock_detail],
        too_small:[L.no_match,L.too_small_detail],
        invalid:[L.invalid,L.invalid_detail],
        insufficient:[L.no_match,L.no_match_detail]
      };
      const message=messages[advice.status]||messages.insufficient;
      root.querySelector('[data-recommend]').textContent=best?(isOneSize(best.size)?L.one_size:L.result.replace('{size}',displaySize(best.size))):message[0];
      root.querySelector('[data-recommend]').classList.toggle('unmatched',!best);
      root.querySelector('[data-detail]').textContent=best?(
        best.referenceFallback?(L.reviewed_estimate_note||L.partial_estimate_note):
        best.basis==='model'?L.model_estimate_note:
        ['partial','label'].includes(best.basis)?L.partial_estimate_note:L.estimate_note
      ):message[1];
      root.querySelector('[data-estimate-caution]').hidden=!best;
      root.querySelector('.model-reference').hidden=!reference;
      root.querySelector('[data-model]').textContent=reference?L.model_reference.replace('{height}',reference.height).replace('{size}',reference.size):'';
      root.querySelector('[data-model-note]').hidden=!reference;
      root.querySelector('.size-details').open=false;
      this.drawComparison(advice);
      root.querySelector('londa-clothing-preview')?.remove();
      const condition=best?.variantId?{...this.body,size:best.size,gender:this.dataset.illustration==='male'?'male':'female',
        mode:'selected',variantId:String(best.variantId),renderStyle:'color-v2'}:null;
      if(condition){
        root.querySelector('londa-fit-preview')?.updateCondition(condition);
      }else{
        root.querySelector('londa-fit-preview')?.clear();
      }
      this.result.hidden=false;this.status.hidden=true;
      this.profileReady=advice.status!=='invalid'&&Boolean(this.body);
      if(persist&&this.profileReady){
        try {localStorage.setItem(key,JSON.stringify({remember:true,height:F.height.value,weight:F.weight.value}));}
        catch {this.status.textContent=L.storage_unavailable;this.status.hidden=false;}
      }
    }
    drawComparison(advice) {
      const root=this.shadowRoot,L=this.labels,groups=new Map();
      const candidates=Array.isArray(advice.candidates)?advice.candidates:[];
      let hasRange=false;
      for(const candidate of candidates){
        let parts=Array.isArray(candidate.parts)?candidate.parts:[];
        if(!parts.length&&candidate.row){
          const dimensions=[['chest','comparison_chest'],['waist','comparison_waist'],['hip','comparison_hip'],['length','comparison_length']]
            .map(([name,label])=>({label:L[label],value:format(LondaFitModel.dimension(candidate.row,name))}))
            .filter(d=>d.value!=='—');
          if(dimensions.length)parts=[{table:0,label:'',size:candidate.size,dimensions}];
        }
        for(const part of parts){
          const dimensions=(Array.isArray(part.dimensions)?part.dimensions:[]).filter(d=>d&&d.label&&d.value!=null&&String(d.value).trim());
          if(!dimensions.length)continue;
          const key=String(part.table??'')+'\u0000'+String(part.label||'');
          if(!groups.has(key))groups.set(key,{label:part.label,columns:[],rows:[]});
          const group=groups.get(key);
          for(const d of dimensions){
            if(!group.columns.includes(d.label))group.columns.push(d.label);
            const range=LondaFitModel.measure(d.value);if(range&&range.max>range.min)hasRange=true;
          }
          group.rows.push({candidate,dimensions});
        }
      }
      const container=root.querySelector('[data-comparison]');container.replaceChildren();
      for(const group of groups.values()){
        const scroll=document.createElement('div');scroll.className='table-scroll';scroll.tabIndex=0;
        scroll.setAttribute('role','region');scroll.setAttribute('aria-label',group.label||L.comparison_title);
        const table=document.createElement('table'),caption=document.createElement('caption');
        const label=group.label&&!/^(SIZE|サイズ)$/i.test(group.label)?group.label+' · ':'';
        caption.textContent=label+(this.chart.unit==='cm'?L.comparison_caption:L.comparison_published_caption);table.append(caption);
        const thead=document.createElement('thead'),head=document.createElement('tr');
        for(const value of [L.comparison_size,...group.columns]){const th=document.createElement('th');th.scope='col';th.textContent=value;head.append(th);}
        thead.append(head);table.append(thead);
        const tbody=document.createElement('tbody');
        for(const {candidate,dimensions} of group.rows){
          const tr=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=candidate.size;
          if(advice.best&&String(advice.best.variantId)===String(candidate.variantId)){
            tr.dataset.recommended='';const note=document.createElement('span');note.className='size-marker';note.textContent=L.comparison_recommended;th.append(note);
          }
          tr.append(th);
          for(const label of group.columns){const td=document.createElement('td');td.textContent=dimensions.find(d=>d.label===label)?.value??'—';tr.append(td);}
          tbody.append(tr);
        }
        table.append(tbody);scroll.append(table);container.append(scroll);
      }
      root.querySelector('.size-details').hidden=groups.size===0&&!advice.reference;
      root.querySelector('[data-range-note]').hidden=!hasRange;
    }
  }

  if (!customElements.get('londa-size-advisor')) customElements.define('londa-size-advisor', LondaSizeAdvisor);
  function init() {
    document.querySelectorAll('[data-londa-size-guide]').forEach(host => {
      if (host.dataset.londaAdvisorReady) return;
      const labels = host.querySelector('[data-londa-advisor-labels]');
      if (!labels) return;
      const mount = () => {
        const guideRoot = host.querySelector('div')?.shadowRoot, container = guideRoot?.querySelector('.measurements');
        if (!container) return false;
        try {
          const chart = JSON.parse(host.querySelector('script[type="application/json"]').textContent);
          const apparel=LondaFitCatalog.isApparel(chart,host.dataset.productTitle,JSON.parse(host.dataset.productTags||'[]'));
          if (!apparel) {
            host.dataset.londaAdvisorReady = 'unsupported';
            const ja=!host.dataset.locale?.startsWith('en');
            host.closest('[data-londa-pdp]')?.querySelectorAll('[data-lpd-open-size]').forEach(button=>{if(button.firstChild?.nodeType===3)button.firstChild.textContent=ja?'サイズ表を見る':'View size chart';});
            const help=document.createElement('p');help.textContent=ja?'掲載寸法を確認し、お手持ちのアイテムと比べてお選びください。':'Check the listed measurements and compare them with an item you own.';help.style.cssText='margin:14px 0;color:#59626c;font-size:13px;line-height:1.7';container.append(help);return true;
          }
          const advisor = document.createElement('londa-size-advisor');advisor.productHost=host;advisor.previewLabels=labels;advisor.setAttribute('data-illustration', labels.dataset.illustration === 'male' ? 'male' : 'female');advisor.chart = chart;advisor.labels = JSON.parse(labels.textContent);advisor.productId=host.dataset.productId;advisor.productHandle=host.dataset.productHandle;advisor.productTitle = host.dataset.productTitle;advisor.fitPreviewCache=host.dataset.fitPreviewCache;advisor.fitGenerationUrl=host.dataset.fitGenerationUrl;advisor.previewLanguage=host.dataset.locale?.startsWith('en')?'en':'ja';container.append(advisor);host.dataset.londaAdvisorReady = '1';
        } catch {host.dataset.londaAdvisorReady = 'invalid';}
        return true;
      };
      if (!mount() && !host.dataset.londaAdvisorWatching) {host.dataset.londaAdvisorWatching = '1';const observer = new MutationObserver(() => {if (mount() || !host.isConnected) observer.disconnect();});observer.observe(host, {childList: true, subtree: true});}
    });
  }
  init();document.addEventListener('shopify:section:load', init);
})();






